<template>
  <!--产品服务-->
  <section id="product">
    <div class="caption caption-white">
      <h1>产品服务</h1>
      <div class="caption-sub middle">
        <div class="flex"></div>
        <span>PRODUCT & SERVICE</span>
        <div class="flex"></div>
      </div>
    </div>

    <div class="bg"></div>

    <div class="grid">
      <div class="prod">
        <div class="btns">
          <router-link class="button prod-1" ref="prod1" to="/product/ticket">
            <h4>票务系统</h4>
            <span>Ticketing System</span>
          </router-link>
          <div class="btns-r">
            <router-link class="button prod-2" ref="prod2" to="/product/bigdata">
              <h4>大数据</h4>
              <span>Big Data</span>
            </router-link>
            <router-link class="button prod-3" ref="prod3" to="/product/ops">
              <h4>运维服务</h4>
              <span>Ops Service</span>
              <!-- <h4>分销平台</h4>
              <span>Distribution Platform</span> -->
            </router-link>
          </div>
          <!-- <a class="button prod-4" ref="prod4">
            <h4>域内客流统计</h4>
            <span>Passenger Flow Statistics</span>
          </a> -->
        </div>
        <div class="img" ref="img1"></div>
      </div>
      <div class="serv">
        <div class="img" ref="img2"></div>
        <div class="btns">
          <div class="btns-l">
            <router-link class="button serv-1" ref="serv1" to="/product/consulting">
              <h4>咨询服务</h4>
              <span>Consulting Services</span>
            </router-link>
            <router-link class="button serv-2" ref="serv2" to="/product/hardware">
              <h4>硬件产品</h4>
              <span>Hardware Product</span>
            </router-link>
          </div>
          <router-link class="button serv-3" ref="serv3" to="/product/commService">
            <h4>社会化服务</h4>
            <span>Community Service</span>
          </router-link>
          <!-- <a class="button serv-2" ref="serv2">
            <h4>运维服务</h4>
            <span>Ops Service</span>
          </a> -->
        </div>
      </div>
    </div>
    <!-- <div style="clear: both;"></div> -->
  </section>

</template>

<script>
import play from "./play";

export default {
  mounted() {
    // play(
    //   [this.$refs.prod1, this.$refs.prod2, this.$refs.prod3, this.$refs.prod4],
    //   "anm-flipInX"
    // );
    // play(
    //   [this.$refs.serv1, this.$refs.serv2, this.$refs.serv3, this.$refs.serv4],
    //   "anm-flipInX"
    // );
    // play([this.$refs.img1, this.$refs.img2], "anm-fadeIn");
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/common.scss";

$SIZE_GRID_BUTTON_HEIGHT: 29.4vw;

section#product {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;

  > .bg {
    background: url(../../assets/images/index/product-bg.png) no-repeat top;
    width: 100%;
    height: 54vw;
    position: absolute;
    top: 0;
    z-index: -1;
  }

  > .grid {
    display: flex;
    flex-direction: column;
    width: $SIZE_PAGE_WIDTH;
    // height: $SIZE_PAGE_WIDTH;

    .btns,
    .img {
      display: flex;
      flex-wrap: wrap;
      width: $SIZE_PAGE_WIDTH / 2;
      height: $SIZE_GRID_BUTTON_HEIGHT;
    }

    .btns > .button {
      width: $SIZE_PAGE_WIDTH / 4;
      height: $SIZE_GRID_BUTTON_HEIGHT / 2;
    }

    h4 {
      font-size: 0.1rem;
      margin-top: 0.2rem;
      margin-bottom: 0;
    }

    span {
      font-size: 0.06rem;
    }

    > .prod > .btns > a,
    > .prod > .btns > .btns-r > a,
    > .serv > .btns > a,
    > .serv > .btns > .btns-l > a {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding-top: 30%;
      color: #ffffff;
    }
    > .prod > .btns > .btns-r > a,
    > .serv > .btns > .btns-l > a {
      width: 100%;
    }

    a {
      text-decoration: none;
    }

    > .prod {
      display: flex;

      > .btns {
        > a.prod-1 {
          background: url(../../assets/images/index/prod-1.png) no-repeat center
            40%;
          background-size: 0.5rem;
          background-color: #145a84;
          height: $SIZE_GRID_BUTTON_HEIGHT;
          padding-top: 33%;
        }
        > .btns-r {
          display: flex;
          flex-wrap: wrap;
          width: $SIZE_PAGE_WIDTH / 4;

          > a.prod-2 {
            background: url(../../assets/images/index/prod-2.png) no-repeat
              center 30%;
            background-size: 0.5rem;
            background-color: #7bb7db;
          }

          > a.prod-3 {
            background: url(../../assets/images/index/prod-3.png) no-repeat
              center 30%;
            background-size: 0.5rem;
            background-color: #b39b6b;
          }
        }
      }
      > .img {
        background: url(../../assets/images/index/product-1.png) no-repeat
          center;
        background-size: cover;
      }
    }

    > .serv {
      display: flex;

      > .img {
        background: url(../../assets/images/index/product-2.png) no-repeat
          center;
        background-size: cover;
      }
      > .btns {
        > .btns-l {
          display: flex;
          flex-wrap: wrap;
          width: $SIZE_PAGE_WIDTH / 4;

          > a.serv-1 {
            background: url(../../assets/images/index/serv-2.png) no-repeat
              center 30%;
            background-size: 0.5rem;
            background-color: #2c7aa8;
          }

          > a.serv-2 {
            background: url(../../assets/images/index/serv-3.png) no-repeat
              center 30%;
            background-size: 0.5rem;
            background-color: #b39b6b;
          }
        }

        > a.serv-3 {
          background: url(../../assets/images/index/serv-1.png) no-repeat center
            40%;
          background-size: 0.5rem;
          background-color: #145a84;
          height: $SIZE_GRID_BUTTON_HEIGHT;
          padding-top: 33%;
        }
      }
    }
  }

  .anm-flipInX {
    animation: flipInX 1s;
    //   animation-fill-mode: forwards;
  }

  .anm-fadeIn {
    animation: fadeIn 3s;
    //   animation-fill-mode: forwards;
  }
}
</style>